import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { FormModule } from '@portal-core/general/components/form/form.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { LicenseOpenAIFormComponent } from './license-open-ai-form.component';

@NgModule({
  declarations: [
    LicenseOpenAIFormComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    FormControlErrorMessageModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    FormModule
  ],
  exports: [
    LicenseOpenAIFormComponent
  ]
})
export class LicenseOpenAIFormModule { }
